import React from "react";
import { AppContext } from "./AppContext";

class TermsAndConditions extends React.Component {
    render() {
        let { termsData } = this.context || {};
        let { isMobile, onClose, getRef, showData } = this.props || {};
        return isMobile ? <div
            ref={getRef}
            style={{
                display: "none",
                paddingTop: "12px",
                width: "90%",
                height: "94%",
                margin: "auto"
            }}>
            <span className="f16 c1 bold">{"TERMS & CONDITIONS"}</span>
            <div className="headingGradient"></div>
            <div style={{ boxShadow: "0px 0px 12px 0px", overflowY: "auto", background: "white", borderRadius: 8, paddingTop: 20 }} dangerouslySetInnerHTML={{ __html: termsData }}></div>
            <img onClick={onClose} style={{ height:30, width:30,  cursor: "pointer", position: "absolute", top: 75, right: 20 }} src={"/images/close_ic@2x.png"} />
        </div> : <div
            ref={getRef}
            onWheel={(e) => {
                e.stopPropagation();
                e.preventDefault();
            }}
             style={{ opacity: 0, position: "relative", display: "none", flexDirection: "column", padding: 20, overflow: "hidden", height: "0px", width: "0px", margin: "auto" }}>
                <span className="f32 c1 bold">{"TERMS & CONDITIONS"}</span>
                <div className="headingGradient"></div>
                <div style={{ boxShadow: "0px 0px 12px 0px", overflow: "auto", background: "white", borderRadius: 8, paddingTop: 20 }} dangerouslySetInnerHTML={{ __html: showData && termsData }}></div>
                <img onClick={onClose} style={{ cursor: "pointer", position: "absolute", top: 20, right: 20 }} src={"/images/close_ic@2x.png"} />
            </div>
    }
}

TermsAndConditions.contextType = AppContext;
export default TermsAndConditions;